"use client"

import type React from "react"
import { Download, X } from "lucide-react"

interface PaymentProofModalProps {
  isOpen: boolean
  imageUrl: string
  onClose: () => void
}

const PaymentProofModal: React.FC<PaymentProofModalProps> = ({ isOpen, imageUrl, onClose }) => {
  if (!isOpen) return null

  const handleDownload = () => {
    const link = document.createElement("a")
    link.href = imageUrl
    link.download = "comprobante-pago.jpg"
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  }

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg shadow-xl w-11/12 max-w-lg mx-auto">
        <div className="flex items-center justify-between p-4 border-b">
          <h2 className="text-lg font-semibold">Comprobante de Pago</h2>
          <button className="p-1 rounded-full hover:bg-gray-200" onClick={onClose}>
            <X className="h-6 w-6" />
          </button>
        </div>
        <div className="p-4">
          <div className="flex justify-center items-center">
            <img src={imageUrl || "/placeholder.svg"} alt="Comprobante de pago" className="max-w-full max-h-[70vh]" />
          </div>
        </div>
        <div className="flex justify-end p-4 border-t">
          <button
            className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
            onClick={handleDownload}
          >
            <Download className="h-4 w-4 mr-2" /> Descargar
          </button>
        </div>
      </div>
    </div>
  )
}

export default PaymentProofModal
